var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPremiumStacking = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 1,
    y2: 1.122,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b246a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37c7f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4960",
    "data-name": "Group 4960",
    transform: "translate(-48 -41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M5340,3835a22,22,0,1,0,15.556,6.444A21.855,21.855,0,0,0,5340,3835m0-5a27,27,0,1,1-27,27A27,27,0,0,1,5340,3830Z",
    transform: "translate(-5265 -3789)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4800",
    "data-name": "Rectangle 4800",
    width: 5,
    height: 26,
    rx: 2,
    transform: "translate(88 72.5) rotate(90)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4801",
    "data-name": "Rectangle 4801",
    width: 5,
    height: 19.102,
    rx: 2,
    transform: "translate(84.551 64.5) rotate(90)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4802",
    "data-name": "Rectangle 4802",
    width: 5,
    height: 14,
    rx: 2,
    transform: "translate(82 56.5) rotate(90)",
    fill: "url(#linear-gradient)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPremiumStacking, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-premium-stacking.6991c251.svg";
export { ForwardRef as ReactComponent };